import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
//Redux
import { Provider } from "react-redux";
import store from "./store";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
